import { fetchToken } from "../../common/FetchCookie"

const url = `https://api.indiahirings.com/employer/company-media`

export const addCompanyMedia = async (data) => {
  try {
    const token = await fetchToken();
    if (!token) throw new Error("Authentication token is missing!");

    const formData = new FormData();

    // Append other fields
    if (data.title) formData.append("title", data.title);
    if (data.type) formData.append("type", data.type);
    if (data.sort_order) formData.append("sort_order", data.sort_order);
    if (data.status) formData.append("status", data.status);

    // Append file if it exists
    if (data.file instanceof File) {
      formData.append("file", data.file);
    }

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(
        errorResponse.response ? JSON.stringify(errorResponse.response) : `Server Error: ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const updateCompanyMedia = async (uuid, data) => {
  const url = `https://api.indiahirings.com/employer/company-media/${uuid}`

  try {
    const token = await fetchToken()
    if (!token) throw new Error("Authentication token is missing!")

    const formData = new FormData()

    Object.keys(data).forEach((key) => {
      if (key !== "file") {
        formData.append(key, data[key])
      }
    })

    if (data.file) {
      const fileArrayBuffer = await data.file.arrayBuffer()
      const fileBlob = new Blob([fileArrayBuffer], { type: data.file.type })
      formData.append("file", fileBlob)
    }

    const response = await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      const errorResponse = await response.json()
      throw new Error(
        errorResponse.response ? JSON.stringify(errorResponse.response) : `Server Error: ${response.statusText}`,
      )
    }

    return await response.json()
  } catch (error) {
    throw error
  }
}

export const deleteCompanyMedia = async (uuid) => {
  const url = `https://api.indiahirings.com/employer/company-media/${uuid}`

  try {
    const token = await fetchToken()
    if (!token) throw new Error("Authentication token is missing!")

    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      const errorResponse = await response.json()
      throw new Error(
        errorResponse.response ? JSON.stringify(errorResponse.response) : `Server Error: ${response.statusText}`,
      )
    }

    return await response.json()
  } catch (error) {
    throw error
  }
}